import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {Session} from "../../services/Session";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {StateService} from "../../services/StateService";
import {ToastService} from "../../services/Toast.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {NumeralService} from "../../services/Numeral.service";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {StateRateService} from "../../tpiq-services/state-rate.service";
import {PROVINCES} from "../../constants/Provinces.constants";
import {takeUntil} from "rxjs/operators";
import {State} from "../../models/State";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {ClientPlansSearchComponent} from "../../search/client-plans-search/client-plans-search.component";
import { getFederalBrackets } from '../../constants/federal-tax-brackets';
import { getCapGainsBrackets } from '../../constants/cap-gains-brackets';
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {ModelBasedNumeral} from "../../directives/model-numeral";
import {ClickOutsideDirective} from "../../directives/click.outside";
import { environment } from '../../../environments/environment';
import {PlanCreationGuardService} from '../../tpiq-services/plan-creation-guard.service';
import {BasicPlanLimitService} from '../../tpiq-services/basic-plan-limit.service';
import {PlanCreationConfirmation} from '../../models/basic-plan-limit.model';
import {Subject} from 'rxjs';

declare const _: any;
declare const jQuery: any;

@Component({
  selector: 'app-client-plans',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, ClientPlansSearchComponent, FroalaEditorModule, ModelBasedNumeral, ClickOutsideDirective],
  templateUrl: './client-plans.component.html',
  styleUrl: './client-plans.component.scss'
})
export class ClientPlansComponent implements OnInit, OnDestroy {
  userTableData: any = {};
  hasUserList = false;
  org: string = Session.getOrg();
  user: any = {};
  taxStrategiesSort: any = {};
  isLoading = false;
  orderArray: any = {
    'Plan Name': 'name',
    Year: 'year',
    Status: 'status',
    'Tax Savings': 'savings',
    ROI: 'roi',
    Actions: ''
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @Input() clientId: any;
  @Input() clientData: any;
  @Input() estimateAccess: any;
  @Input() currentSubscription: string;
  @Input() userReadOnly: any;
  @Output() onUpdationOfClient: EventEmitter<any> = new EventEmitter<any>();

  actionsData = [{
    name: 'Duplicate Plan',
  }, {
    name: 'Rename Plan',
  }, {
    name: 'Related Parties',
  }, {
    name: 'Invoice',
  }];
  reveal: any = {
    extraOptions: false,
    addNewTaxplan: false,
    customStatus: false,
    creationFail: false,
    editClient: false
  };
  duplicatePlanName: string;
  duplicatePlanYear: any;
  currentPlan: any;
  newPlanName: string;
  columns: Array<any> = [
    {
      name: 'name',
      title: 'Plan Name',
      type: 'html',
      classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip',
      sortable: true
    },
    {
      name: 'year',
      title: 'Year',
      type: 'normal',
      classes: 'type-column pointer zero-overflow table-header-badge-tooltip',
      sortable: true
    },
    {
      name: 'status',
      title: 'Status',
      type: 'badge-input-search',
      'status-col': true,
      displayName: 'name',
      classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip',
      sortable: true
    },
    {
      name: 'savings',
      title: 'Tax Savings',
      type: 'normal',
      classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip',
      sortable: true
    },
    {
      name: 'roi',
      title: 'ROI',
      type: 'badge-input-search',
      'status-col': true,
      classes: 'associated-column pointer zero-overflow tracker-desc table-header-badge-tooltip',
      sortable: true
    },
    {
      name: 'homeState',
      title: 'Home State',
      type: 'badge-input-search',
      'status-col': true,
      displayName: 'name',
      classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip',
      sortable: false
    },
    {
      name: 'lastUpdatedBy',
      title: 'Last Updated By',
      type: 'normal',
      classes: 'type-column pointer zero-overflow table-header-badge-tooltip',
      sortable: false
    },
    {
      name: 'lastUpdatedDate',
      title: 'Last Updated Date',
      type: 'normal',
      classes: 'type-column pointer zero-overflow table-header-badge-tooltip',
      sortable: true
    },
  ];
  orgName: string;
  filters: Array<any> = [];
  columnsForPdf: Array<any> = [
    {name: 'name', title: 'Plan Name'},
    {name: 'year', title: 'Year'},
    {name: 'status', title: 'Status'},
    {name: 'savings', title: 'Tax Savings'},
    {name: 'roi', title: 'ROI'},
    {name: 'homeState', title: 'Home State'}
  ];
  sortColumnName: any;
  sortColumnOrder: any;
  searchText: any;
  states: Array<any>;
  allProvinces: Array<any> = PROVINCES.COUNTRY_PROVINCES;

  clientPlans: any;
  /* Fields related to badge input popup */
  displayWidget: boolean;
  displayDropdown = false;
  selectedRow: any = {};
  selectedCol: any = {};
  searchEntries: Array<any> = [];
  dropSearchString: string;
  widgetLoader: boolean;
  statusTypes: Array<any> = [{name: 'Not Started'}, {name: 'Drafted'}, {name: 'Prepared'}, {name: 'Pitched'}, {name: 'Closed - Won'}, {name: 'Closed - Lost'}, {name: 'Custom'}];
  planCustomStatus = '';

  /* Filing Status for Tax Plan Creation Modal */
  filingStatusList: Array<any> = [
    {name: 'Single'},
    {name: 'Married Filing Jointly (MFJ)'},
    {name: 'Married Filing Separately (MFS)'},
    {name: 'Head of Household'},
    {name: 'Estate'},
    {name: 'Trust'},
  ];

  /**
   * Maps client filing status to dropdown list values
   * Handles cases where client data may not have (MFJ)/(MFS) suffixes
   */
  private mapClientFilingStatus(clientStatus: string): string {
    if (!clientStatus) return 'Single';

    // Handle exact matches first
    const exactMatch = this.filingStatusList.find(item => item.name === clientStatus);
    if (exactMatch) return clientStatus;

    // Handle legacy values and abbreviations
    const mappings: { [key: string]: string } = {
      // Legacy full names without suffixes
      'Married Filing Jointly': 'Married Filing Jointly (MFJ)',
      'Married Filing Separately': 'Married Filing Separately (MFS)',
      // RAP abbreviations (from state-rate.service.ts patterns)
      'MFJ': 'Married Filing Jointly (MFJ)',
      'MFS': 'Married Filing Separately (MFS)',
      'Married': 'Married Filing Jointly (MFJ)',
      'Joint': 'Married Filing Jointly (MFJ)',
      // Common abbreviations
      'S': 'Single',
      'HOH': 'Head of Household'
    };

    if (mappings[clientStatus]) {
      return mappings[clientStatus];
    }
    console.warn(`Unrecognized filing status "${clientStatus}", defaulting to Single`);
    return 'Single';
  }

  /**
   * Gets the appropriate default filing status for the dropdown
   * Ensures the value always matches an item in filingStatusList
   */
  get defaultFilingStatus(): string {
    if (this.newTaxPlan.filingStatus) {
      return this.mapClientFilingStatus(this.newTaxPlan.filingStatus);
    }
    return this.mapClientFilingStatus(this.clientData?.filingStatus);
  }

  /**
   * Checks if a tax year is supported for state rate calculations
   * @param year The tax year to check
   * @returns true if the year is supported for state rate calculations
   */
  private isStateRateYearSupported(year: number | string): boolean {
    return this.SUPPORTED_STATE_RATE_YEARS.includes(year?.toString());
  }

  /**
   * Converts display format to database storage format
   * Database column is limited in length, so we store abbreviations
   * @param displayFormat The full format shown in UI
   * @returns Abbreviated format for database storage
   */
  private convertToStorageFormat(displayFormat: string): string {
    if (!displayFormat) return null;

    // Convert full display format to database abbreviations
    const storageMap: { [key: string]: string } = {
      'Single': 'Single',
      'Married Filing Jointly (MFJ)': 'MFJ',
      'Married Filing Separately (MFS)': 'MFS',
      'Head of Household': 'Head of Household', // May need abbreviation if too long
      'Estate': 'Estate',
      'Trust': 'Trust'
    };

    return storageMap[displayFormat] || displayFormat;
  }

  /* Supported years for state rate calculations */
  private readonly SUPPORTED_STATE_RATE_YEARS = ['2024', '2025', '2026'];

  /* Fields for Tax Plan Creation*/
  newTaxPlan: any = {
    totalTax: 0,
    taxableIncome: 0,
    effectiveRate: 0,
    marginalRate: 0,
    capGainRate: 0,
    ccropFlatRate: '21',
    marketGrowthRate: '5',
    customTaxRates: []
  };
  showField = true;
  showDesc: boolean;
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Internal notes about this plan',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events: {},
    key: environment.froalaKey
  };
  searchKey: string;
  errorMessage = '';
  years: Array<any> = [];
  currentYear: any;
  basicRestrictionsActive = false;
  creationBlocked = false;
  creationBlockMessage = '';
  creatingPlan = false;
  duplicatingPlan = false;
  private creationAvailabilitySequence = 0;
  private readonly createConfirmationCancel$ = new Subject<void>();
  private readonly duplicateConfirmationCancel$ = new Subject<void>();
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private stateService: StateService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private taxPlanningService: TaxPlanningService,
    private numeralService: NumeralService,
    private changeDetectorRef: ChangeDetectorRef,
    private stateRateService: StateRateService,
    private planCreationGuard: PlanCreationGuardService,
    private basicPlanLimits: BasicPlanLimitService
  ) {
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.orgName = this.user.org || '';
    this.currentYear = new Date().getFullYear();
    this.loadBasicRestrictions();
    this.basicPlanLimits.invalidated$.pipe(takeUntil(this.destroy$)).subscribe(change => {
      if (!change.orgId || change.orgId === this.org) {
        this.loadBasicRestrictions();
      }
    });
    if (!this.userReadOnly) {
      this.columns.push({
        name: 'planActions',
        title: 'Actions',
        type: 'input-currency',
        classes: 'input-currency amount-column pointer zero-overflow amount-column-width table-header-badge-tooltip',
        sortable: false
      });
    }
    this.newTaxPlan.clientId = this.clientId;
    this.newTaxPlan.userId = this.clientData.email;
    const orgCountryCode: any = Session.getUser().orgCountryCode || 'US';
    this.fillYears();
    this.filterStates(orgCountryCode);
    this.getClientPlans();
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
        this.deleteClientPlan(toast.data);
      }
    });
    this.switchBoard.onClientPlansAdvSearch.pipe(takeUntil(this.destroy$)).subscribe(search => {
      if (search.filters) {
        this.filters = search.filters;
      }
      if (search.searchObj) {
        this.advSearchInClientPlans(search.searchObj);
      } else {
        this.advSearchInClientPlans(search);
      }
    });
    this.switchBoard.onClearMenuFilter.pipe(takeUntil(this.destroy$)).subscribe(click => {
      if (click == 'clientPlansSearch') {
        this.getClientPlans(this.sortColumnName, this.sortColumnOrder);
      }
    });
  }

  ngOnDestroy(): void {
    this.createConfirmationCancel$.next();
    this.createConfirmationCancel$.complete();
    this.duplicateConfirmationCancel$.next();
    this.duplicateConfirmationCancel$.complete();
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.switchBoard.onToggleFeedback.next({
      display: false
    });
  }

  advSearchInClientPlans(search) {
    if (search.searchText) {
      this.searchText = search.searchText;
      this.getClientPlans(this.sortColumnName, this.sortColumnOrder, search.searchText);
    }
  }

  getClientPlans(sortColumn?, sortOrder?, searchText?) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClientPlansList(this.org, this.user.id, this.clientId, sortColumn, sortOrder, searchText)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.hasUserList = true;
        this.clientPlans = _.cloneDeep(response);
        const data = response || [];
        this.formRowsDataForTable(data);
        this.savePaidPlansToGlobalArray();
      }, (error) => {
        this.isLoading = false;
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  savePaidPlansToGlobalArray() {
    const paidPlans = this.taxPlanningService.getPaidPlans();
    _.each(this.clientPlans, (plan) => {
      if (plan.paid && !_.includes(paidPlans, plan.id)) {
        paidPlans.push(plan.id);
      }
    });
    this.taxPlanningService.setPaidPlans(paidPlans);
  }

  formRowsDataForTable(data) {
    const base = this;
    if (data && data.length > 0) {
      _.each(data, function (plan) {
        plan.savings = base.numeralService.format('$0,0', plan.savings);
        plan.roi = (plan.roi) ? (plan.roi + '%') : '';
        plan.homeState = (plan.homeState) ? base.getStateName(plan.homeState) : '';
      });
    }
    this.userTableData = data;
  }

  getStateName(stateCode) {
    const stateObject = _.find(this.states, {short: stateCode});
    return (stateObject && stateObject.name) ? stateObject.name : '';
  }

  deleteClientPlan(data) {
    this.verifyDeletionAllowed(Number(data.taxYear || this.currentYear), () => {
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.deleteClientTaxPlan(this.org, this.user.id, data.planId)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Plan deleted successfully');
          this.getClientPlans();
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete plan');
        });
    });
  }

  private loadBasicRestrictions(): void {
    this.basicPlanLimits.get(this.org, this.user.id, this.currentYear, this.clientId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: entitlement => this.basicRestrictionsActive = entitlement.basicRestrictionsActive,
        error: () => this.basicRestrictionsActive = true
      });
  }

  private verifyDeletionAllowed(taxYear: number, onAllowed: () => void): void {
    this.basicPlanLimits.get(this.org, this.user.id, taxYear, this.clientId, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: entitlement => {
          this.basicRestrictionsActive = entitlement.basicRestrictionsActive;
          if (entitlement.canDelete) {
            onAllowed();
            return;
          }
          this.toastService.pop(TOAST_TYPE.warning,
            'Plans created under the Basic subscription cannot be deleted. Please chat with Support through the Hub for corrections.');
        },
        error: () => {
          this.basicRestrictionsActive = true;
          this.toastService.pop(TOAST_TYPE.error, 'Failed to verify plan deletion access');
        }
      });
  }

  addState() {
    const data = {clientId: this.clientId};
    this.stateService.addState(new State('client-overview', this._router.url, data, null));
  }

  handleActionOnRowOfPlan(action, planData) {
    this.currentPlan = planData;
    if (action) {
      if (action == 'Related Parties') {
        this.reveal.editClient = true;
      } else if (action == 'Duplicate Plan') {
        this.duplicatePlanName = this.currentPlan.name;
        this.reveal['duplicate-plan'] = true;
      } else if (action == 'Rename Plan') {
        this.newPlanName = this.currentPlan.name;
        this.reveal['rename-plan'] = true;
      } else if (action == 'Send Proposal' || action == 'Engagement Letter' || action == 'Invoice') {
        this.reveal.extraOptions = true;
      }
    }
  }

  hideReveal(key) {
    if (key == 'duplicate-plan') {
      this.duplicateConfirmationCancel$.next();
      this.duplicatingPlan = false;
      this.duplicatePlanName = '';
      this.duplicatePlanYear = '';
    } else if (key == 'addNewTaxplan') {
      this.createConfirmationCancel$.next();
      this.creatingPlan = false;
      this.newTaxPlan = {
        ccropFlatRate: '21',
        marketGrowthRate: '5',
        customTaxRates: []
      };
    }
    this.planCustomStatus = '';
    this.reveal[key] = false;
  }

  createDuplicate() {
    if (this.duplicatingPlan) {
      return;
    }
    const obj = {
      action: 'duplicate',
      newName: this.duplicatePlanName,
      CustomerEmail: this.clientId
    };
    if (this.validateDuplicatePlanYear()) {
      this.duplicatingPlan = true;
      const taxYear = Number(this.duplicatePlanYear);
      this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientId, taxYear)
        .pipe(takeUntil(this.duplicateConfirmationCancel$))
        .subscribe({
          next: confirmation => {
            if (!confirmation) {
              this.duplicatingPlan = false;
              return;
            }
            this.submitDuplicate(obj, taxYear, confirmation);
          },
          error: error => {
            this.duplicatingPlan = false;
            this.toastService.pop(TOAST_TYPE.error,
              this.planCreationGuard.errorMessage(error, 'Failed to verify plan entitlement'));
          }
        });
    }
  }

  private submitDuplicate(obj: any, taxYear: number, confirmation: PlanCreationConfirmation,
                          countChangeRetryAttempted = false): void {
    const request = {...obj, ...confirmation};
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.duplicatePlan(this.org, this.user.id, this.currentPlan.id, request, taxYear)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.basicPlanLimits.invalidate(this.org, taxYear);
        this.toastService.pop(TOAST_TYPE.success, 'Plan duplicated successfully');
        this.hideReveal('duplicate-plan');
        this.getClientPlans();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        if (this.planCreationGuard.shouldRetryCountChange(error, countChangeRetryAttempted)) {
          this.planCreationGuard.confirmCreate(this.org, this.user.id, this.clientId, taxYear,
            confirmation.creationRequestId).pipe(takeUntil(this.duplicateConfirmationCancel$)).subscribe({
              next: refreshed => {
                if (refreshed) {
                  this.submitDuplicate(obj, taxYear, refreshed, true);
                } else {
                  this.duplicatingPlan = false;
                }
              },
              error: refreshError => {
                this.duplicatingPlan = false;
                this.toastService.pop(TOAST_TYPE.error,
                  this.planCreationGuard.errorMessage(refreshError, 'Failed to verify plan entitlement'));
              }
            });
          return;
        }
        this.hideReveal('duplicate-plan');
        this.errorMessage = this.planCreationGuard.errorMessage(error, 'Failed to duplicate a plan');
        this.reveal.creationFail = true;
      });
  }

  validateDuplicatePlanYear() {
    let validateTrue = true;
    if (!this.duplicatePlanName) {
      validateTrue = false;
      this.toastService.pop(TOAST_TYPE.error, 'Plan name is mandatory');
      return false;
    }
    if (this.duplicatePlanYear) {
      const planYear = parseInt(this.duplicatePlanYear);
      if (planYear < 2010 || planYear > 2050) {
        validateTrue = false;
        this.toastService.pop(TOAST_TYPE.error, 'Please enter in a valid plan year.');
        return false;
      }
    } else {
      validateTrue = false;
      this.toastService.pop(TOAST_TYPE.error, 'Plan year is mandatory');
      return false;
    }
    return validateTrue;
  }

  stopPropagation($event) {
    $event && $event.stopImmediatePropagation();
  }

  renamePlan() {
    this.loadingService.triggerLoadingEvent(true);
    const obj = {
      action: 'rename',
      newName: this.newPlanName
    };
    this.taxPlanningService.renamePlan(this.org, this.user.id, this.currentPlan.id, obj)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Plan renamed successfully');
        this.getClientPlans();
        this.newPlanName = '';
        this.hideReveal('rename-plan');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to rename plan');
      });
  }

  deletePlanFromTable(planData) {
    this.verifyDeletionAllowed(Number(planData.year || this.currentYear), () => {
      this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure to delete plan?', {
        planId: planData.id,
        taxYear: planData.year
      });
    });
  }

  showPlan(planData) {
    this.addState();
    this._router.navigate(['tax-planning', 'client', this.clientId, planData.id, planData.year, 'client_plan'], {queryParams: {fromListPage: true}});
  }

  applyPlanAction($event, planData) {
    this.handleActionOnRowOfPlan($event.name, planData);
  }

  columnSort(column, columns) {
    if (column.sortable) {
      let order = this.getSortType(column);
      this.taxStrategiesSort[column.name] = order;
      this.sortColumnName = column.name;
      this.sortColumnOrder = order;
      // Map frontend column names to backend column names
      const backendSortColumn = this.mapColumnNameToBackend(column.name);
      this.getClientPlans(backendSortColumn, order, this.searchText);
      this.resetSortOrder(column, columns);
    }
  }

  mapColumnNameToBackend(columnName: string): string {
    // Map frontend column names to backend database column names
    // Only needed for columns where frontend camelCase doesn't match SQL snake_case
    // Other columns like 'name', 'status', 'year' either match exactly or have special backend handling
    const columnMapping: { [key: string]: string } = {
      'lastUpdatedDate': 'updated_date',  // Frontend: camelCase, SQL: snake_case
      'lastUpdatedBy': 'updated_by'        // Frontend: camelCase, SQL: snake_case (alias)
    };
    return columnMapping[columnName] || columnName;
  }

  resetSortOrder(column, columns) {
    _.each(columns, function (col) {
      if (col.name !== column.name) {
        col.sortType = '';
      }
    });
  }

  getSortType(column) {
    if (!column.sortType) {
      column.sortType = 'asc';
    } else if (column.sortType == 'asc') {
      column.sortType = 'desc';
    } else if (column.sortType == 'desc') {
      column.sortType = 'asc';
    }
    return column.sortType;
  }

  showROI(planData) {
    this.addState();
    this._router.navigate(['tax-planning', 'client', this.clientId, planData.id, planData.year, 'roi_page'], {queryParams: {fromListPage: true}});
  }

  filterStates(stateName) {
    this.states = _.filter(this.allProvinces, function (state) {
      return state.country === stateName;
    });
    this.searchEntries = this.states;
  }

  onMouseClick(e: MouseEvent, row, column) {
    const base = this;
    this.dropSearchString = '';
    this.selectedRow = _.cloneDeep(row);
    this.selectedCol = _.cloneDeep(column);
    if (column.name == 'homeState') {
      this.searchEntries = _.cloneDeep(this.states) || [];
    } else if (column.name == 'status') {
      this.searchEntries = _.cloneDeep(this.statusTypes) || [];
    }
    const popupHeight = 250, // hardcode these values
      popupWidth = 250;    // or compute them dynamically

    let popupXPosition,
      popupYPosition;

    if (e.clientX + popupWidth > window.innerWidth) {
      popupXPosition = e.pageX - popupWidth;
    } else {
      popupXPosition = e.pageX;
    }

    if (e.clientY + popupHeight > window.innerHeight) {
      popupYPosition = e.pageY - popupHeight;
    } else {
      popupYPosition = e.pageY;
    }

    if (base.selectedCol.view && base.selectedCol.view === 'inReveal') {
      popupYPosition = popupYPosition - 55;
      popupXPosition = popupXPosition - 140;
    }
    this.selectedCol.editable = this.selectedCol.editable === undefined ? true : this.selectedCol.editable;
    this.displayDropdown = true;
    this.displayWidget = false;
    setTimeout(() => {
      this.displayWidget = true;
      this.detectChanges();
    }, 10);
    setTimeout(() => {
      jQuery('#widget-container').css({
        top: popupYPosition,
        left: popupXPosition,
        position: 'absolute',
        padding: '5px'
      });
    }, 20);
  }

  detectChanges(): void {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  closeContainer() {
    this.displayWidget = false;
    this.dropSearchString = '';
    if (!this.reveal.customStatus) {
      this.selectedRow = {};
      this.selectedCol = {};
    }
    this.detectChanges();
  }

  removeItem($event, entryObj) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
  }

  triggerOnSelect($event, entry) {
    if (this.selectedCol.name == 'status' && entry.name == 'Custom') {
      this.planCustomStatus = '';
      this.reveal.customStatus = true;
    } else {
      const data: any = _.find(this.clientPlans, {id: this.selectedRow.id});
      this.resetSearchEntries();
      if (this.selectedCol.name == 'homeState') {
        data['homeState'] = entry.short;
      } else if (this.selectedCol.name == 'status') {
        data['status'] = entry.name;
      }
      this.updatePlan(data);
    }
  }

  resetSearchEntries() {
    const base = this;
    setTimeout(() => {
      base.searchEntries = [];
      base.displayDropdown = false;
      base.displayWidget = false;
      base.detectChanges();
    }, 200);
  }

  filterEntries($event) {
    const base = this;
    const searchString = $event.target.value || '';
    if (searchString) {
      this.searchEntries = _.filter(this.states, function (obj) {
        return obj.name.toLowerCase().indexOf(searchString.toLowerCase()) != -1;
      });
    } else {
      this.searchEntries = _.cloneDeep(this.states);
    }
  }

  navigateToTaxEstimates(planData) {
    this.addState();
    this._router.navigate(['tax-planning', 'client', this.clientId, planData.id, planData.year, 'tax_estimates'], {queryParams: {fromListPage: true}});
  }

  updatePlanStatus() {
    const data: any = _.find(this.clientPlans, {id: this.selectedRow.id});
    this.resetSearchEntries();
    data['status'] = this.planCustomStatus;
    this.updatePlan(data);
    this.reveal.customStatus = false;
  }

  updatePlan(data) {
    if (data && data.id) {
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.updateTaxPlanHomeState(this.org, this.user.id, this.clientId, data.id, data)
        .subscribe((response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.getClientPlans();
          this.toastService.pop(TOAST_TYPE.success, 'Plan updated successfully.');
        }, (error) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed update plan');
        });
    }
  }

  addNewTaxPlan() {
    this.newTaxPlan.clientId = this.clientId;
    this.newTaxPlan.userId = this.clientData.email;
    this.newTaxPlan.taxYear = new Date().getFullYear();
    this.loadCreationAvailability();

    // Reinitialize numeric properties to prevent undefined → 0 conversion during change detection
    this.newTaxPlan.totalTax = 0;
    this.newTaxPlan.taxableIncome = 0;
    this.newTaxPlan.effectiveRate = 0;
    this.newTaxPlan.marginalRate = 0;
    this.newTaxPlan.capGainRate = 0;

    // Initialize filing status from client data if available (modal only)
    // IMPORTANT: Always use mapped/normalized value to prevent data corruption
    this.newTaxPlan.filingStatus = this.mapClientFilingStatus(this.clientData.filingStatus);

    this.reveal.addNewTaxplan = true;
  }

  createTaxPlan() {
    if (this.creatingPlan || !this.validateData()) {
      return false;
    }
    this.creatingPlan = true;
    const taxYear = Number(this.newTaxPlan.taxYear);
    this.planCreationGuard.confirmCreate(this.org, this.user.id, this.newTaxPlan.clientId, taxYear)
      .pipe(takeUntil(this.createConfirmationCancel$))
      .subscribe({
        next: confirmation => {
          if (!confirmation) {
            this.creatingPlan = false;
            return;
          }
          this.newTaxPlan.id = '';
          this.newTaxPlan.strategyTypes = [{strategies: []}];
          this.newTaxPlan.creationRequestId = confirmation.creationRequestId;
          this.newTaxPlan.confirmedCreditNumber = confirmation.confirmedCreditNumber;
          this.getFormattedCustomRates();

          // Plan creation API updates the client and expects the abbreviated storage format.
          this.newTaxPlan.filingStatus = this.convertToStorageFormat(this.newTaxPlan.filingStatus);

          this.submitTaxPlan(taxYear, confirmation);
        },
        error: error => {
          this.creatingPlan = false;
          this.toastService.pop(TOAST_TYPE.error,
            this.planCreationGuard.errorMessage(error, 'Failed to verify plan entitlement'));
        }
      });
  }

  private submitTaxPlan(taxYear: number, confirmation: PlanCreationConfirmation,
                        countChangeRetryAttempted = false): void {
    this.newTaxPlan.creationRequestId = confirmation.creationRequestId;
    this.newTaxPlan.confirmedCreditNumber = confirmation.confirmedCreditNumber;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.createTaxPlanForClient(this.org, this.user.id, this.newTaxPlan).subscribe({
      next: (response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.creatingPlan = false;
        this.basicPlanLimits.invalidate(this.org, taxYear);
        this.toastService.pop(TOAST_TYPE.success, 'Tax Plan created successfully');
        this.hideReveal('addNewTaxplan');
        this.getClientPlans();
      },
      error: (error) => {
        this.loadingService.triggerLoadingEvent(false);
        if (this.planCreationGuard.shouldRetryCountChange(error, countChangeRetryAttempted)) {
          this.planCreationGuard.confirmCreate(this.org, this.user.id, this.newTaxPlan.clientId, taxYear,
            confirmation.creationRequestId).pipe(takeUntil(this.createConfirmationCancel$)).subscribe({
              next: refreshed => {
                if (refreshed) {
                  this.submitTaxPlan(taxYear, refreshed, true);
                } else {
                  this.creatingPlan = false;
                }
              },
              error: refreshError => {
                this.creatingPlan = false;
                this.toastService.pop(TOAST_TYPE.error,
                  this.planCreationGuard.errorMessage(refreshError, 'Failed to verify plan entitlement'));
              }
            });
          return;
        }
        this.creatingPlan = false;
        this.hideReveal('addNewTaxplan');
        this.errorMessage = this.planCreationGuard.errorMessage(error, 'Failed to create tax plan');
        this.reveal.creationFail = true;
      }
    });
  }

  getFormattedCustomRates() {
    const indiStateTaxRate = {
      name: 'Ind State Rate',
      rate: this.newTaxPlan.individualStateRate,
      formula: "{\"actualValue\":\"\",\"displayValue\":\"\",\"displayValuesArray\":[],\"actualValuesArray\":[],\"type\":\"individual\"}"
    };
    const indiCorporateTaxRate = {
      name: 'Corp State Rate',
      rate: this.newTaxPlan.corporateStateRate,
      formula: "{\"actualValue\":\"\",\"displayValue\":\"\",\"displayValuesArray\":[],\"actualValuesArray\":[],\"type\":\"corporate\"}"
    };
    if (this.newTaxPlan.homeState) {
      indiStateTaxRate.name = this.newTaxPlan.homeState + ' ' + indiStateTaxRate.name;
      indiCorporateTaxRate.name = this.newTaxPlan.homeState + ' ' + indiCorporateTaxRate.name;
    }
    const customRates = (this.newTaxPlan.customTaxRates || [])
      .filter(rate => !this.isGeneratedStateRate(rate));
    this.newTaxPlan.customTaxRates = [...customRates, indiStateTaxRate, indiCorporateTaxRate];
  }

  validateData() {
    const base = this;
    if (!this.newTaxPlan.clientId) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select client');
      return false;
    }
    if (!this.newTaxPlan.name) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Plan name');
      return false;
    }
    if (!this.newTaxPlan.filingStatus) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select Filing Status');
      return false;
    }
    if (this.newTaxPlan.marginalRate === undefined ||
        this.newTaxPlan.marginalRate === null ||
        this.newTaxPlan.marginalRate === '' ||
        !Number.isFinite(Number(this.newTaxPlan.marginalRate))) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Marginal Rate');
      return false;
    }
    if (this.newTaxPlan.capGainRate === undefined ||
        this.newTaxPlan.capGainRate === null ||
        this.newTaxPlan.capGainRate === '' ||
        !Number.isFinite(Number(this.newTaxPlan.capGainRate))) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Cap Gain Rate');
      return false;
    }
    if (!this.newTaxPlan.ccropFlatRate) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter CCorp Flat Rate');
      return false;
    }
    if (!this.newTaxPlan.taxYear) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Tax Plan year');
      return false;
    }
    if (!this.newTaxPlan.homeState) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select state');
      return false;
    }
    let result = true;
    const customTaxRates = (this.newTaxPlan.customTaxRates || [])
      .filter(rate => !this.isGeneratedStateRate(rate));
    const submittedNames = customTaxRates
      .map(rate => String(rate.name || '').trim().toLowerCase())
      .filter(name => !!name)
      .concat(this.generatedStateRateNames().map(name => name.toLowerCase()));
    if (new Set(submittedNames).size !== submittedNames.length) {
      this.toastService.pop(TOAST_TYPE.error, 'Custom rate names must be unique');
      return false;
    }
    _.each(customTaxRates, function (customTaxRate) {
      if (customTaxRate.name && !customTaxRate.rate) {
        base.toastService.pop(TOAST_TYPE.error, `Please enter rate for ${customTaxRate.name}`);
        result = false;
      }
      if (!customTaxRate.name && customTaxRate.rate) {
        base.toastService.pop(TOAST_TYPE.error, `Please give name for Tax rate`);
        result = false;
      }
    });
    return result;
  }

  private generatedStateRateNames(): string[] {
    const prefix = this.newTaxPlan.homeState ? `${this.newTaxPlan.homeState} ` : '';
    return [`${prefix}Ind State Rate`, `${prefix}Corp State Rate`];
  }

  private isGeneratedStateRate(rate: any): boolean {
    return typeof rate?.formula === 'string'
      && (rate.formula.includes('"type":"individual"') || rate.formula.includes('"type":"corporate"'));
  }

  calculateEffectiveRate() {
    if (this.newTaxPlan.totalTax != 0 && this.newTaxPlan.taxableIncome != 0
      && !isNaN(this.newTaxPlan.totalTax) && !isNaN(this.newTaxPlan.taxableIncome)) {
      this.newTaxPlan.effectiveRate = Math.round((this.newTaxPlan.totalTax / this.newTaxPlan.taxableIncome) * 100);

      // Auto-calculate marginal and cap gains rates if filing status is selected (modal only)
      // Use setTimeout to defer calculations to next change detection cycle to avoid ExpressionChangedAfterItHasBeenCheckedError
      if (this.newTaxPlan.filingStatus) {
        setTimeout(() => {
          this.calculateMarginalRateForModal();
          this.calculateCapGainsRateForModal();
          this.recalculateStateRatesForModal();
        }, 0);
      }

      this.showField = false;
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
      this.showField = true;
      this.showDesc = true;
    }
  }

  showRatesInfo() {
    window.open('https://taxfoundation.org/data/all/federal/2026-tax-brackets/');
  }

  onHomeStateSelect(state) {
    if (!_.isEmpty(state)) {
      this.newTaxPlan.homeState = state.short;
      if (this.newTaxPlan.taxYear && this.isStateRateYearSupported(this.newTaxPlan.taxYear)) {
        // Use selected filing status from the form, fallback to mapped client data, then 'Single'
        const filingStatus = this.newTaxPlan.filingStatus || this.mapClientFilingStatus(this.clientData.filingStatus);
        this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(state.name, filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
        this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(state.name, filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
      }
    }
  }

  /**
   * Manual Plan Creation Modal - Filing Status Selection Handler
   * Auto-calculates marginal rate and cap gains rate based on filing status + taxable income
   * SCOPE: Only affects this modal form, does not impact other components
   */
  onFilingStatusSelect(status: any) {
    this.newTaxPlan.filingStatus = status.name;

    // Auto-calculate marginal rate and cap gains rate on filing status change (matches RAP behavior)
    // Use setTimeout to defer calculations to next change detection cycle to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.calculateMarginalRateForModal();
      this.calculateCapGainsRateForModal();
      this.recalculateStateRatesForModal();
    }, 0);
  }

  /**
   * Calculate marginal rate for manual plan creation modal only
   * Uses year-aware calculation to match the modal's tax year
   * SCOPE: Only for this modal form
   */
  private calculateMarginalRateForModal() {
    // Defensive guard: Don't update during initial rendering to prevent ExpressionChangedAfterItHasBeenCheckedError
    if (!this.newTaxPlan.filingStatus ||
        this.newTaxPlan.taxableIncome === undefined ||
        this.newTaxPlan.taxableIncome === null ||
        !this.newTaxPlan.taxYear) {
      return;
    }

    // Validate taxable income is a finite number before calculation
    const numericTaxableIncome = Number(this.newTaxPlan.taxableIncome);
    if (!Number.isFinite(numericTaxableIncome)) {
      return;
    }

    // Use year-aware calculation instead of hard-coded current year
    const rate = this.getMarginalRateForYear(
      numericTaxableIncome,
      this.newTaxPlan.filingStatus,
      this.newTaxPlan.taxYear
    );

    // Only update if utility returns valid rate and it's different from current value
    if (rate !== undefined && rate !== null && !isNaN(rate) && this.newTaxPlan.marginalRate !== rate) {
      this.newTaxPlan.marginalRate = rate;
    }
  }

  /**
   * Calculate capital gains rate for manual plan creation modal only
   * Uses year-aware calculation to match the modal's tax year
   * SCOPE: Only for this modal form
   */
  private calculateCapGainsRateForModal() {
    // Defensive guard: Don't update during initial rendering to prevent ExpressionChangedAfterItHasBeenCheckedError
    if (!this.newTaxPlan.filingStatus ||
        this.newTaxPlan.taxableIncome === undefined ||
        this.newTaxPlan.taxableIncome === null ||
        !this.newTaxPlan.taxYear) {
      return;
    }

    // Validate taxable income is a finite number before calculation
    const numericTaxableIncome = Number(this.newTaxPlan.taxableIncome);
    if (!Number.isFinite(numericTaxableIncome)) {
      return;
    }

    // Use year-aware calculation instead of hard-coded current year
    const rate = this.getCapGainsRateForYear(
      numericTaxableIncome,
      this.newTaxPlan.filingStatus,
      this.newTaxPlan.taxYear
    );

    // Only update if utility returns valid rate and it's different from current value
    if (rate !== undefined && rate !== null && !isNaN(rate) && this.newTaxPlan.capGainRate !== rate) {
      this.newTaxPlan.capGainRate = rate;
    }
  }

  /**
   * Recalculate state rates using the selected filing status
   * SCOPE: Only for this modal form
   */
  private recalculateStateRatesForModal() {
    if (this.newTaxPlan.homeState && this.newTaxPlan.filingStatus && this.newTaxPlan.taxYear) {
      const state = this.states.find(s => s.short === this.newTaxPlan.homeState);
      if (state && this.isStateRateYearSupported(this.newTaxPlan.taxYear)) {
        this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(
          state.name,
          this.newTaxPlan.filingStatus,
          this.newTaxPlan.taxableIncome,
          this.newTaxPlan.taxYear
        );
        this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(
          state.name,
          this.newTaxPlan.filingStatus,
          this.newTaxPlan.taxableIncome,
          this.newTaxPlan.taxYear
        );
      }
    }
  }

  /**
   * Year-aware marginal rate calculation for specific tax year
   * Unlike getMarginalRate() which hard-codes current year, this uses the specified year
   */
  private getMarginalRateForYear(taxableIncome: number, filingStatus: string, taxYear: number): number {
    const brackets = getFederalBrackets(taxYear)[filingStatus];
    if (!brackets || taxableIncome <= 0) return 0;

    let rate = 0;
    for (const bracket of brackets) {
      rate = bracket.rate;
      if (taxableIncome <= bracket.upTo) break;
    }
    return rate * 100; // return as percentage (e.g. 24 not 0.24)
  }

  /**
   * Year-aware capital gains rate calculation for specific tax year
   * Unlike getCapGainsRate() which hard-codes current year, this uses the specified year
   */
  private getCapGainsRateForYear(taxableIncome: number, filingStatus: string, taxYear: number): number {
    const brackets = getCapGainsBrackets(taxYear)[filingStatus];
    if (!brackets || taxableIncome <= 0) return 0;

    let rate = 0;
    for (const bracket of brackets) {
      rate = bracket.rate;
      if (taxableIncome <= bracket.upTo) break;
    }
    return rate * 100; // return as percentage
  }

  showStateRatesInfo(type) {
    if (type == 'individual') {
      window.open('https://taxfoundation.org/publications/state-individual-income-tax-rates-and-brackets/');
    } else if (type == 'corporate') {
      window.open('https://taxfoundation.org/publications/state-corporate-income-tax-rates-and-brackets/');
    }
  }

  addCustomTaxRate() {
    this.newTaxPlan.customTaxRates.push({});
    setTimeout(() => {
      this.scrollToBottom();
    }, 50);
  }

  removeCustomTaxRate(index) {
    this.newTaxPlan.customTaxRates.splice(index, 1);
  }

  filterData() {
    if (!this.searchKey) {
      this.userTableData = [];
      const data = _.cloneDeep(this.clientPlans);
      this.formRowsDataForTable(data);
    } else {
      const base = this;
      this.userTableData = [];
      const list = _.cloneDeep(this.clientPlans) || [];
      const filteredList = [];
      const columns = this.columns;
      _.each(list, (plan) => {
        _.each(base.columns, (column) => {
          if (column.name != 'savings' && column.name != 'roi') {
            if (plan[column.name] && plan[column.name].toLowerCase().indexOf(base.searchKey.toLowerCase()) != -1) {
              const tempPlan = _.find(filteredList, {id: plan.id});
              if (!tempPlan) {
                filteredList.push(plan);
              }
            }
          }
        });
      });
      this.formRowsDataForTable(filteredList);
    }
  }

  fillYears() {
    for (let i = this.currentYear - 5; i <= this.currentYear + 5; i++) {
      this.years.push({id: i.toString(), name: i.toString()});
    }
  }

  setYear($event) {
    this.newTaxPlan['taxYear'] = $event.id;
    this.loadCreationAvailability(true);
  }

  private loadCreationAvailability(forceRefresh = false): void {
    const loadSequence = ++this.creationAvailabilitySequence;
    const taxYear = Number(this.newTaxPlan.taxYear);
    if (!taxYear || !this.newTaxPlan.clientId) {
      return;
    }
    this.basicPlanLimits.get(this.org, this.user.id, taxYear, this.newTaxPlan.clientId, forceRefresh)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: entitlement => {
          if (loadSequence !== this.creationAvailabilitySequence
            || taxYear !== Number(this.newTaxPlan.taxYear)) {
            return;
          }
          this.creationBlocked = entitlement.basicRestrictionsActive && !entitlement.canCreate;
          this.creationBlockMessage = this.creationBlocked
            ? `Your Basic subscription cannot create another plan for ${taxYear}. Use the Upgrade link in the header to request an upgrade.`
            : '';
        },
        error: () => {
          if (loadSequence !== this.creationAvailabilitySequence
            || taxYear !== Number(this.newTaxPlan.taxYear)) {
            return;
          }
          this.creationBlocked = true;
          this.creationBlockMessage = 'Failed to verify plan creation access. Please try again.';
        }
      });
  }

  refreshClient() {
    this.reveal.editClient = false;
    this.onUpdationOfClient.emit();
  }

  scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

}
